import React from "react";

import styles from "./styles.module.scss";

const CommandsWrapper = ({ header, body, footer }) => (
    <div className={styles.templateWrapper}>
        <div className={styles.header}>
            {header}
        </div>

        <div className={styles.body}>
            {body}
        </div>

        <div className={styles.footer}>
            {footer}
        </div>
    </div>
);

export default CommandsWrapper;
